<template>
	<div class="term_service">
		<h3 class="term_service_title">{{ t('termService.title') }}</h3>
		<div class="term_service_list" v-html="t('termService.list')"></div>
	</div>
</template>

<script lang="ts" setup>
// @ts-ignore
definePageMeta({
	isShowSelectCurrency: false,
	isShowSelectLanguage: false,
});
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<style lang="scss" scoped>
.term_service {
	width: 100%;
	&_title {
		font-size: 28rem;
		text-align: center;
		color: #993441;
	}
	&_list {
		height: 60vh;
		overflow-y: scroll;
		:deep(p) {
			font {
				font-size: 14rem !important;
				font-family: Montserrat, MontserratAlternates, PingFangSC-Light, 'PingFang SC', STHeitiSC-Light, Helvetica-Light, Arial, sans-serif !important;
				color: rgba(0, 0, 0, 0.85) !important;
				font-weight: 400;
			}
		}
	}
}
</style>
